/* istanbul ignore file */
import React from 'react';

function getLocalizedMessage(table, key) {
    return `${table}:${key}`;
}

export default React.createContext(getLocalizedMessage);
